/**
 * This function is used to check whether the given language is
 * a Chinese or Japanese language or not. These languages are without
 * spaces between the words.
 */

export function isLanguageWithoutWordSpaces(language?: string): boolean {
    return ['zh', 'ja'].some(lang => lang === language);
}
